import React from 'react';
import { AuthProvider } from './AuthProvider';
import { DataProvider } from './DataProvider';
import { UIProvider } from './UIProvider';

/**
 * AppProviders - Single provider that wraps all context providers
 * Organized into 3 logical groups: Auth, Data, and UI
 *
 * This replaces the previous 9-level deep nesting with a cleaner 3-group structure
 */
export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <DataProvider>
        <UIProvider>
          {children}
        </UIProvider>
      </DataProvider>
    </AuthProvider>
  );
}
